// LocalStorage key for the client-side "active profile" selection. The header derived from it
// (X-Portal-Link-Id) lets per-patient portal reads resolve to the selected PatientPortalLink; the backend
// re-validates ownership + active status on every request, so this is a hint, never a trust boundary.
export const ACTIVE_LINK_STORAGE_KEY = 'portal.active_link_id';
